import './styles/App.css'
import React, { useEffect, useState } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import { BrowserRouter } from "react-router-dom";
import { NuqsAdapter } from "nuqs/adapters/react";
import { useAuthStore } from '../features/auth';
import { AppRouter } from './providers/Router';
import { AppUpdater } from './providers/AppUpdater/AppUpdater';
import { PushNavigator } from './providers/PushNavigator/PushNavigator';
import { setOnSessionExpired } from '../shared/config/axios';

function App() {
  const [queryClient] = useState(() => new QueryClient());
  const checkAuth = useAuthStore((s) => s.checkAuth);

  useEffect(() => {
    // Register session-expiry handler so the axios interceptor can clear auth state
    // via the store instead of doing a hard page reload.
    setOnSessionExpired((reason) => useAuthStore.getState().logout(reason));
    checkAuth();
  }, [checkAuth]);
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <NuqsAdapter>
          <AppRouter />
          {/* Watches for a new deploy and reloads into it when nothing on screen would be lost. */}
          <AppUpdater />
          {/* Routes a notification tap that the service worker sent to an already-open window. */}
          <PushNavigator />
        </NuqsAdapter>
      </BrowserRouter>
    </QueryClientProvider>

  );
}

export default App;